export const SAFE_ACTIONS = {
  BUY_CHECK: "Проверить покупку",
  WATCH: "Умеренно бычий сценарий / наблюдать вход",
  HOLD: "Держать",
  REDUCE: "Снизить риск",
  SELL_CHECK: "Проверить продажу",
};

export const DISCLAIMER = {
  advisory: "Не финансовая консультация",
  guarantee: "Без гарантий",
  helper: "Помощник анализа",
};

export const ZURICH_TIME_ZONE = "Europe/Zurich";

export const HIGH_IMPACT_TERMS = [
  "CPI",
  "Core CPI",
  "PPI",
  "Core PCE",
  "Nonfarm Payrolls",
  "NFP",
  "Unemployment Rate",
  "Fed Interest Rate Decision",
  "FOMC Minutes",
  "FOMC",
  "Powell Speech",
  "GDP",
  "Retail Sales",
  "Initial Jobless Claims",
  "Jobless Claims",
];

export const NEWS_TOPICS = [
  "gold",
  "XAUUSD",
  "inflation",
  "Federal Reserve",
  "interest rates",
  "USD",
  "DXY",
  "treasury yields",
  "recession",
  "central banks gold buying",
  "geopolitical risk",
  "safe haven",
  "war",
  "banking crisis",
];

export const CACHE_KEYS = {
  goldPrice: "gold:price",
  goldHistory: (interval = "1d", range = "30d") => `gold:history:${interval}:${range}`,
  macro: "macro:latest",
  news: "news:finnhub:gold",
  calendar: "calendar:upcoming",
  aiNews: "ai:news-analysis",
  signal: "signal:latest",
};

export const CACHE_TTL_SECONDS = {
  goldPrice: 180,
  goldHistory: 1800,
  macro: 2700,
  news: 900,
  calendar: 3600,
  aiNews: 1200,
  signal: 180,
};
